<template>
    <overlay-modal ref="overlayModal" width="65%">
        <template v-slot:header>
            <div class="d-flex justify-content-between">
                <h4>Dettaglio volo</h4>
            </div>
        </template>
        <template>
            <div class="modal-flight-detail">
                <DefaultPanel class="flight-panel" title="Volo selezionato" :is-selected="selected">
                    <template v-slot:top-right>
                        <div class="d-flex" @click="onSelect">
                            <h3 :class="value.prezzoVenditaDelta>0? 'more' : 'minus'">{{value.prezzoVenditaDelta>0? '+' + value.prezzoVenditaDelta:value.prezzoVenditaDelta}} &euro;</h3>
                        </div>
                    </template>
                    <template>
                        <FlightSection :value=value mode="detail" />
                    </template>
                </DefaultPanel>
            </div>
        </template>
    </overlay-modal>
</template>

<script>
import OverlayModal from '../../../modals/OverlayModal'
import FlightPanel from '../FlightPanel'
import FlightSection from '../flight-panel/FlightSection'
import DefaultPanel from '../../../templates/DefaultPanel'
export default {
  name: 'ModalFlightDetail',
  components: {DefaultPanel, FlightSection, FlightPanel, OverlayModal},
  props: {
    value: {
      type: Object
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    open: function () {
      this.$refs.overlayModal.open()
    },
    close: function () {
      this.$refs.overlayModal.close()
    },
    onSelect: function () {
      this.$emit('select', this.value)
      this.close()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/modals/ModalFlightDetail.vue